import { curatedBaseApi } from "./baseApi";
import { getAllFaqCategoriesQs, getAllFaqsQs, getFaqFromCategoryQs } from "./faqQsFilters";
const curatedAPIToken = process.env.REACT_APP_CURATED_API_TOKEN;

const faqCategoriesPath = "/faq-categories"
const faqsPath = "/faqs"
const headers = {
  authorization: `Bearer ${curatedAPIToken}`,
}

export const faqApi = curatedBaseApi.injectEndpoints({
  endpoints: (build) => ({

    // gets all faq categories
    getAllFaqCategories: build.query({
      query: () => {
        return {
          url: `${faqCategoriesPath}?${getAllFaqCategoriesQs}`,
          method: 'GET',
          headers
        }
      },
      transformResponse: (response) => response.data
    }),

    // Gets all FAQs
    getAllFaqs: build.query({
      query: (crpVersion) => ({
        url: `${faqsPath}?${getAllFaqsQs(crpVersion)}`,
        method: "GET",
        headers
      }),
      transformResponse: (response) => response.data
    }),


    // Gets faqs by category
    getFaqsFromCategory: build.query({
      query: ({ category, crpVersion }) => ({
        url: `${faqsPath}?${getFaqFromCategoryQs(category, crpVersion)}`,
        method: 'GET',
        headers
      }),
      transformResponse: (response) => response.data
    })


  }),
  overrideExisting: false
})

export const {
  useGetAllFaqCategoriesQuery,
  useGetAllFaqsQuery,
  useGetFaqsFromCategoryQuery,
} = faqApi